import React from 'react'
import { List } from './components/List/List'
import { Pay } from './components/Pay/Pay'
import { useTranslation } from 'react-i18next';

export const Unpaid = () => {

  const { t } = useTranslation();

  return (
    <div className='flex flex-col my-container   gap-4' >
      <div className='flex flex-row justify-between items-center'>
        <span className='text-gray-500 text-sm'>{t('PleaseSelectVisas')}</span>
        <Pay />
      </div>
      <div className='border rounded-lg border-gray-200'>
        <List />
      </div>
    </div>
  )
}
